import React from 'react';
import { HeroContent } from './HeroContent';
import { HeroQuotePanel } from './HeroQuotePanel';
import { TrustBar } from './TrustBar';
import { Services } from './Services';
import { Reviews } from './Reviews';
import { Comparison } from './Comparison';
import { ProblemSolution } from './ProblemSolution';
import { DoorGlass } from './DoorGlass';
import { Process } from './Process';
import { ShowerGlass } from './ShowerGlass';
import { Mirrors } from './Mirrors';
import { DeckScreens } from './DeckScreens';
import { WhyChooseUs } from './WhyChooseUs';
import { ServiceArea } from './ServiceArea';
import { ResidentialGlassFAQ } from '../../components/ResidentialGlassFAQ/ResidentialGlassFAQ';
import { FinalCTA } from './FinalCTA';
import { StickyMobileCTA } from './StickyMobileCTA';
export function ResidentialGlass() {
  return <main className="w-full bg-white pb-20 lg:pb-0" data-id="element-1351">
      <section className="bg-white pt-8 pb-12 lg:pt-10 lg:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-1352">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start" data-id="element-1353">
          <HeroContent data-id="element-1354" />
          <HeroQuotePanel data-id="element-1355" />
        </div>
      </section>
      <TrustBar data-id="element-1356" />
      <Services data-id="element-1357" />
      <Reviews data-id="element-1358" />
      <Comparison data-id="element-1359" />
      <ProblemSolution data-id="element-1360" />
      <DoorGlass data-id="element-1361" />
      <Process data-id="element-1362" />
      <ShowerGlass data-id="element-1363" />
      <Mirrors data-id="element-1364" />
      <DeckScreens data-id="element-1365" />
      <WhyChooseUs data-id="element-1366" />
      <ServiceArea data-id="element-1367" />
      <ResidentialGlassFAQ data-id="element-1368" />
      <FinalCTA data-id="element-1369" />
      <StickyMobileCTA data-id="element-1370" />
    </main>;
}